.wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;

    &.corners {
        border-radius: 4px;
    }
}